import { render } from "./GlobalTransactionNowpaymentsView.vue?vue&type=template&id=1aafd50f"
import script from "./GlobalTransactionNowpaymentsView.vue?vue&type=script&lang=js"
export * from "./GlobalTransactionNowpaymentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__